import { ProspectModel } from './prospect.model'

export class ProspectsModel {
  total: number
  totalPages: number
  currentPage: number
  limit: number
  items: ProspectModel[] = []

  constructor(data) {
    this.total = data.total ? data.total : 0
    this.totalPages = data.totalPages ? data.totalPages : 0
    this.currentPage = data.currentPage ? data.currentPage : 1
    this.limit = data.limit ? data.limit : 1

    for (let i = 0; i < data.items.length; i++) {
      this.items.push(new ProspectModel(data.items[i]))
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/track/prospects.model.ts